// We have no control over the query params expected in these URLs
/* eslint-disable camelcase */
import { makeBookingUrl } from '../bookings/urls';
import { Source } from '../common/constants';
import { addQueryParams } from '../common/routing/addQueryParams';
import { PRACTICE_APPOINTMENTS_URL } from '../common/urls';
import { SearchResultAppointment } from './types';

export const makeAppProfileDeepLink = (type: 'practice' | 'practitioner', id: string) =>
  addQueryParams('https://he.app.link/search2app', { [type]: id });

export const makePracticeBookNowUrl = (id: string, specialty: string) =>
  makeBookingUrl('book', id, specialty, 'today', '?source=serp');

export const makeAppointmentUrl = (appointment: SearchResultAppointment, vaccineType?: string) => {
  const practiceId = String(appointment.practiceId);
  const practitionerId = appointment.appointmentPractitionerId;
  const specialty = String(appointment.specialty);
  const date = appointment.date;
  const time = (appointment.time || '').replace(/:/, '');

  const baseUrl = makeBookingUrl('book', practiceId, specialty, `${date}T${time}`);

  return addQueryParams(baseUrl, {
    practitioner: practitionerId,
    source: 'serp',
    vaccineType,
  });
};

export const makePracticeBookingUrl = (
  defaultPracticeUrl: string,
  mobile: boolean,
  id: string,
  specialty?: string,
  vaccineType?: string,
) => {
  if (mobile) {
    return addQueryParams(PRACTICE_APPOINTMENTS_URL, {
      id,
      doc_id: '0',
      source: 'serp',
      specialty,
      vaccineType,
    });
  }

  return addQueryParams(defaultPracticeUrl, { show_all_appts: '1', specialty, vaccineType });
};

interface PractitionerBookingUrlProps {
  defaultPractitionerUrl: string;
  mobile: boolean;
  practitionerId: string;
  practiceId?: string;
  specialty?: string;
  vaccineType?: string;
}

export const makePractitionerBookingUrl = ({
  defaultPractitionerUrl,
  mobile,
  practitionerId,
  practiceId,
  specialty,
  vaccineType,
}: PractitionerBookingUrlProps) => {
  if (mobile) {
    return addQueryParams(`/public/practitioner/appointments.php`, {
      id: practitionerId,
      source: 'serp',
      specialty,
      vaccineType,
    });
  }

  return addQueryParams(defaultPractitionerUrl, {
    show_all_appts: '1',
    location: practiceId,
    specialty,
    vaccineType,
  });
};

export const makePracticeContactUrl = (defaultUrl: string) =>
  `${defaultUrl}#practice-contact-anchor`;

export const addPracticeIdToPractitionerUrl = (url: string, practiceId?: string) =>
  addQueryParams(url, { location: practiceId });

export const makePractitionerContactUrl = (defaultUrl: string) =>
  `${defaultUrl}#practice-contact-anchor`;

export const makeAppointmentLightboxUrl = (
  id: string,
  specialty?: string,
  vaccineType?: string,
  source?: Source | string,
) =>
  addQueryParams(PRACTICE_APPOINTMENTS_URL, {
    id,
    source: source ?? 'serp',
    specialty,
    target: '_parent',
    vaccineType,
  });

export const makeCovaxLightboxUrl = (id: string, vaccineType?: string) =>
  addQueryParams('/covid-19-vaccine/find', {
    id,
    source: 'serp',
    target: '_parent',
    vaccineType,
  });
